<template>
  <div @click="goToRoute(`/cooking-detail/${data.id}/${$root.slugGenerator(data.title)}`)" class="cookingCart d-flex flex-direction-column align-items-end">
    <div class="image">
      <img v-if="data.image!=null" :src="$root.baseImageUrl+data.image" :alt="data.title" />
      <div class="chef">
        <img v-if="data.userImage!=null&&data.userImage!='string'" :src="$root.baseImageUrl+data.userImage" :alt="data.userInfo" />
        
<svg  v-else version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" 
	 width="70" height="70"
	 viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
<g id="_x30_402-chef">
	<g>
		<path style="fill-rule:evenodd;clip-rule:evenodd;" d="M103.74,11.631c-0.262-3.292-1.569-5.538-3.15-7.512
			C98.182,2.086,95.293,0.529,91.382,0H87.02c-2.914,0.398-5.228,1.396-7.513,2.423c-0.512,0.62-1.19,1.071-1.938,1.454
			c-0.071,0.494-0.656,0.475-0.727,0.969c-0.637-0.071-0.191,0.94-0.969,0.728c-2.2-1.731-5.225-2.565-8.239-3.394
			c-5.045-1.383-10.772-1.957-17.205-1.695c-2.566,0.262-4.941,0.713-7.27,1.211c-0.684,0.771-2.288,0.621-2.908,1.454
			c-1.286,0.169-1.744,1.165-2.908,1.455c-0.787,0.989-1.675,1.878-2.665,2.665c0,0.809-0.789,0.826-0.728,1.696
			c-0.55,0.075-0.359,1.034-0.484,1.211c-0.089,0.126-0.558-0.05-0.485,0.243c-6.931-0.146-11.461,2.109-14.782,5.573
			c-0.805,1.78-1.944,3.225-1.938,5.815c-0.011,2.354,0.944,3.741,1.696,5.332c1.04,0.818,1.901,1.814,2.908,2.665
			c0.664,0.226,1.034,0.743,1.697,0.97c0.426,0.543,1.453,0.484,1.939,0.969c2.475,0.213,4.333-0.189,5.331-1.453
			c0.196-1.164,0.799-2.566,0-3.393c-1.168-0.361-0.503,1.111-1.454,0.969c-0.507,0.383-1.609,0.168-2.181,0.484
			c-0.219-0.508-1.368-0.086-1.454-0.727c-0.858,0.131-0.597-0.858-1.454-0.727c-0.823-1.277-2.046-2.154-2.424-3.877
			c0.177-0.742-0.418-0.713-0.241-1.455c0.238-0.568,0.424-1.189,0.484-1.939c1.137-1.368,2.346-2.662,4.12-3.393
			c1.895-0.851,4.222-1.27,6.543-1.695c1.405,0.031,2.29-0.457,3.635-0.484c0.245-0.401,1.029-0.264,1.455-0.484
			c0.629-0.098,0.729-0.723,1.453-0.727c0.316-1.285-1.186-0.753-0.969-1.939c1.545-1.443,3.374-2.603,5.332-3.635
			c2.461-0.932,5.358-1.426,8.481-1.696c5.511-0.302,10.06,0.409,14.297,0.97c2.55,0.336,4.972,0.472,7.27,1.211
			c0.562,0.648,1.58,0.844,1.938,1.696c0.856,0.356,0.785,1.638,2.181,1.454c1.103-0.271,1.031-1.715,0.969-3.15
			c2.63-1.166,5.233-2.36,8.724-2.665h5.331c3.247,0.872,5.895,2.344,6.785,5.574v2.664c-0.288,0.681-0.545,1.394-0.727,2.181
			c-0.564,0.972-1.509,1.561-1.938,2.666c-0.655,0.631-1.842,1.774-1.212,2.908c0.219,1.234,2.588,0.32,3.393,0.97
			c0.048,2.712-1.357,3.973-2.666,5.33c-1.309,1.438-4.522,0.97-5.573,2.667c0.46,0.396,0.369,0.656,0.727,0.97
			c0.552,0.479,1.418,0.651,1.938,0.726c1.079,0.154,1.976-0.117,2.908,0c0.205-0.521,1.063-0.391,1.455-0.726
			c0.513-0.296,0.704-0.913,1.454-0.97c1.57-2.065,3.165-4.105,3.393-7.514c-0.245-1.045-0.369-2.215-0.727-3.15
			C102.482,17.32,103.72,15.086,103.74,11.631z M61.818,25.685c1.125-1.123,0.05-3.158,0-4.603
			c-0.652-1.205-0.954-2.762-1.697-3.877h-1.453c0.054,0.457-0.273,0.535-0.243,0.969c0.158,1.619,0.527,3.027,0.969,4.361
			C59.806,23.981,59.632,26.015,61.818,25.685z M76.357,24.475c0.427-0.705,0.552-1.709,0.728-2.666
			c0.351-0.588,0.559-2.708-0.485-2.665c-0.053-0.189-0.203-0.282-0.485-0.241c-0.002,0.319-0.424,0.22-0.484,0.483
			c-1.015,2.604-2.597,5.717-2.181,8.967C75.801,28.441,75.897,26.275,76.357,24.475z M47.52,32.229
			c0.607-0.2,0.767-0.849,1.212-1.211c-0.207-2.218-1.713-3.136-2.423-4.847c-0.478-0.735-0.976-1.448-1.454-2.182
			c-0.491-0.803-0.772-1.813-2.181-1.697c-0.821-0.012-1.051,0.564-1.454,0.971c-0.067,2.57,1.591,3.416,2.181,5.33
			C44.503,30.076,44.898,32.266,47.52,32.229z M99.378,65.187c-0.971-0.807-2.064-1.491-3.15-2.183
			c-0.685,0.201-0.628-0.341-1.212-0.242c-0.426-0.139-1.424,0.293-1.454-0.241c0.09-1.624-0.022-3.048-0.484-4.12
			c0.037-0.771,0.55-1.064,0.484-1.938c-0.394-0.575-0.47-1.468-0.727-2.181c-0.479-0.572-0.839-1.26-1.212-1.939
			c-0.849-1.17-1.728-2.311-2.665-3.393c-0.953-0.528-1.337,0.504-1.938,0c0.852-0.765-0.853-1.173,0-1.938
			c0.106-0.943,0.183-1.918,0.484-2.666c0.191-1.829,0.752-3.287,0.969-5.089c0.509-1.511,0.615-3.423,1.212-4.847
			c0.583-1.422,0.849-3.876-0.969-4.119c-2.141-0.203-2.444,1.433-2.908,2.908c-0.49,1.447-0.773,3.104-1.212,4.604
			c-0.333,1.605-0.663,3.215-0.97,4.846c-0.17,0.799-0.389,1.551-0.484,2.424c-0.473,0.577,0.147,2.248-0.728,2.424
			c-4.361-1.375-9.253-2.218-14.539-2.666c-10.471-0.374-19.074,1.12-25.93,4.363c-1.11-3.494-2.169-7.041-3.149-10.664
			c-0.502-0.629-0.295-1.967-0.97-2.423c-0.073-1.058-0.251-2.009-0.727-2.666c-0.33-2.013-0.593-4.093-1.939-5.089
			c-1.67-0.297-2.14,0.607-2.665,1.454c0.02,4.262,1.601,6.96,2.181,10.662c0.573,1.608,1.063,3.298,1.453,5.089
			c0.363,0.688,0.506,1.596,0.728,2.424c0.247,0.318,0.237,0.893,0.484,1.213c-0.315,0.6,0.711,1.004,0,1.211
			c-1.044,0.236-0.705-0.912-1.454-0.97c0.531,1.349-0.341,2.067-1.211,2.665c-0.609,0.926-1.032,2.037-1.697,2.908
			c-0.048,1.164-0.648,1.775-0.484,3.15c-0.956,0.902-1.489,2.227-1.939,3.635c-0.169,1.058,0.699,1.077,0.727,1.938
			c-0.839-0.453-1.716-0.867-3.15-0.727c-0.826,0.547-1.953,0.795-2.423,1.696c-0.978,0.396-1.089,1.657-1.939,2.181
			c-0.655,1.912-1.753,4.461-0.97,7.028c0.305,0.099,0.496,0.312,0.485,0.728c0.873,0.178,1.224,0.875,2.423,0.727
			c0.498,0.633,2.434-0.17,2.909,0.484c-0.816,4.758-1.533,9.615-1.455,15.267c0.346,5.022,2.044,9.677,3.877,12.845
			c0.678,1.169,1.275,2.049,1.939,2.907c0.368,0.476,0.63,0.822,0.969,1.212c0.974,1.116,2.007,2.109,2.909,2.908
			c0.402,0.355,0.736,0.604,1.211,0.969c0.314,0.242,0.584,0.708,0.969,0.969c0.214,0.146,0.542,0.127,0.726,0.242
			c0.146,0.09,0.325,0.383,0.485,0.486c7.017,4.461,16.599,6.713,28.109,6.299c9.008-0.928,15.364-4.507,20.599-9.208
			c4.876-5.14,8.931-11.101,9.935-20.113c0.114-6.416-0.361-12.239-1.454-17.448c1.1-0.677,2.222-1.332,2.907-2.423
			c0.038-0.285-0.042-0.688,0.242-0.727c0.145-1.275-0.179-2.081-0.242-3.15C99.964,66.377,99.557,65.895,99.378,65.187z
			 M28.861,72.455c-1.106-0.105-2.668,0.245-3.392-0.242c0.001-2.826,1.171-4.482,2.422-6.059c0.924-0.424,1.78-0.617,2.667,0
			C29.943,68.207,29.236,70.165,28.861,72.455z M90.654,56.22c-0.348,0.702-1.1,0.999-1.938,1.212
			c-0.316-1.529,0.491-1.934,0.485-3.15C90.067,54.545,90.01,55.732,90.654,56.22z M88.716,53.312
			C89.441,53.359,88.484,54.317,88.716,53.312C87.99,53.262,88.948,52.305,88.716,53.312z M42.674,54.281
			c0.997-0.135,1.567-0.695,2.666-0.727c-0.89,1.048-1.951,1.926-3.393,2.422C42.271,55.494,42.409,54.823,42.674,54.281z
			 M91.382,96.93c-1.663,3.912-4.125,7.022-6.786,9.937c-1.611,1.296-3.299,2.517-4.847,3.877
			c-3.305,1.622-6.783,3.071-11.147,3.634h-7.027c-4.525-0.402-8.65-1.203-12.359-2.422c-0.772-0.521-1.914-0.672-2.665-1.212
			c-0.93-0.282-1.566-0.858-2.424-1.212c-1.628-0.795-2.845-2.002-4.362-2.908c-0.618-1.35-1.642-2.426-2.423-3.877
			c-0.98-1.039-1.526-2.512-2.423-3.635c-1.349-2.77-1.915-6.324-2.423-9.936c-0.135-3.123,0.159-5.818,0.243-8.724
			c0.594-4.011,1.923-7.284,2.908-10.904c0.684-1.659,1.129-3.556,1.696-5.331c0.162-0.97,0.602-1.661,0.969-2.424
			c0.307-0.826,0.336-1.926,0.728-2.664c0.789-0.554,1.507,0.641,2.908,0.241c1.658-0.524,2.924-1.438,4.12-2.424
			c0.531-0.518,1.347-0.755,1.697-1.454c0.494-0.071,0.475-0.655,0.969-0.727c-0.173-0.658,1.142,0.173,0.97-0.484
			c1.462,0.314,1.145,2.408,2.908,2.422c3.997,0.04,4.835-3.078,7.027-4.846c0.971,0.24,1.269,1.154,2.665,0.969
			c1.57-0.287,2.58-1.137,3.636-1.938c1.103,0.483,2.267,0.546,3.15-0.243c4.65,0.036,8.361,1.009,12.358,1.696
			c0.339,2.73,1.161,4.979,2.424,6.787c0.896,0.556,1.975,0.932,3.15,1.211c0.274,1.018,1.146,1.438,1.453,2.422
			c0.324,0.888,0.925,1.5,1.212,2.425c0.864,1.56,1.468,3.378,2.181,5.088c1.205,3.722,2.182,7.673,2.182,12.601
			C93.765,88.168,93.203,93.18,91.382,96.93z M96.712,70.031c-0.856-0.113-0.889-1.049-1.212-1.695
			c-0.318-0.65-0.649-1.287-0.969-1.938c-0.291-0.318-0.094-0.382,0-0.727c1.408,0.288,2.164,1.228,2.909,2.18
			c0.011,0.161-0.015,0.325,0,0.485C97.521,69.236,97.367,69.732,96.712,70.031z M79.265,64.943c-0.56-0.976-1.97-1.1-2.909-1.696
			c-0.891-0.079-2.146,0.208-2.665-0.243c-1.479,0.542-4.216-0.177-4.12,1.939c0.192,1.988,3.403,0.959,5.332,1.211
			c1.783,0.316,2.731,1.47,4.604,1.696C80.559,67.219,80.247,65.465,79.265,64.943z M53.093,65.912
			c0.517-0.614,2.001-0.262,1.939-1.453c-0.189-0.861-1.335-0.766-1.939-1.212c-1.48-0.188-2.267,0.317-3.634,0.243
			c-2.372,0.82-6.19,1.344-5.332,4.604c0.95,0.517,1.316-0.487,2.181-0.727c0.757-0.374,1.745-0.518,2.423-0.97
			C50.269,66.319,51.404,65.84,53.093,65.912z M60.606,84.087c1.82,0.325,4.864,0.755,4.846-1.454
			c-0.292-1.403-1.787-1.605-3.634-1.453c-0.939-0.598-2.349-0.721-2.908-1.695c0.518-2.148,1.636-3.695,1.939-6.059
			c0.472-0.901,0.657-2.092,0.727-3.394c0.345-0.899,0.46-2.825-0.727-2.907h-0.485c0.011,0.335-0.114,0.532-0.243,0.727
			c-0.822,1.843-1.219,4.112-1.939,6.059c-0.515,2.231-1.812,3.682-1.938,6.3C56.958,82.24,58.936,83.01,60.606,84.087z
			 M47.763,76.575c4.12,1.932,4.914-4.374,2.666-6.058C47.314,69.391,46.213,74.541,47.763,76.575z M74.176,70.759
			c-1.08-0.358-1.502-0.078-2.423,0.243c-1.33,1.676-1.452,6,1.212,6.301C75.579,77.172,75.763,72.246,74.176,70.759z
			 M50.185,91.114h2.666c1.446-0.331,2.776-0.778,3.877-1.454c2.111-0.473,3.868-1.3,4.12-3.635
			c-0.075-1.057-0.878-1.383-1.454-1.938h-2.181c-1.946,1.042-2.996,2.981-5.089,3.878c-0.808,0-1.615-0.001-2.422,0
			c-0.055-0.189-0.203-0.282-0.485-0.242c-0.504-0.143-0.783-0.51-1.212-0.729c-0.245-0.424-0.418-1.299-0.969-0.727
			c-0.833,2.336,0.715,3.822,2.181,4.604C49.579,90.913,50.111,90.785,50.185,91.114z M63.514,89.176
			c0.591,0.622,1.533,0.891,2.181,1.454c0.362,0.042,0.895-0.087,0.969,0.241c1.876,0.249,3.425-0.264,4.604-0.483
			c1.362-0.253,2.181-0.134,2.666-0.728c0.058-0.071,0.396,0.044,0.484,0c0.085-0.041,0.411-0.394,0.485-0.484
			c0.064-0.079,0.396,0.059,0.484,0c0.465-0.312,1.343-1.325,1.697-1.938c0.419-0.729,1.128-1.677,0.484-2.665
			c-0.052-0.273-0.27-0.377-0.484-0.485c-0.875,1.79-2.651,2.682-5.089,2.907c-0.821-0.067-1.393-0.385-2.424-0.241
			c-0.205-0.36-0.78-0.351-1.212-0.485c-0.206-0.358-0.609-0.521-1.21-0.484c-0.304-0.908-1.055-1.369-2.181-1.454
			C63.14,84.831,62.648,87.312,63.514,89.176z M59.151,92.326c-0.243-0.001-0.288,0.196-0.484,0.242
			c-0.321,0.406-0.642,0.812-0.485,1.696c0.754,1.589,3.219,1.468,5.574,1.454c0.101-0.543,1.286-0.007,1.453-0.484
			c0.135-0.592,0.938-0.516,0.728-1.454C65.106,91.865,61.801,92.423,59.151,92.326z M74.903,103.23
			c-0.878,1.061-2.101,1.777-3.393,2.424c-0.782,0.35-1.797,0.463-2.665,0.727H63.03c-2.801-0.431-5.916-0.547-7.997-1.695
			c-1.446-0.17-2.214-1.018-3.393-1.455c-1.204-0.572-1.362-2.193-3.15-2.182c-0.003,0.483-0.662,0.309-0.485,0.971
			c0.075,2.35,1.735,3.111,2.909,4.361c4.473,2.635,10.586,3.63,17.932,3.395c1.008-0.447,2.643-0.267,3.392-0.971
			c1.511-0.023,1.904-1.166,3.15-1.455c1.283-1.705,3.27-2.707,2.908-6.057C76.831,100.7,75.969,102.634,74.903,103.23z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>

        <!-- <img v-else  src="@/assets/front/images/user.jpg" :alt="data.userInfo" /> -->
        <h4 class="blackColor04">
          {{ data.userInfo!=" "?data.userInfo:this.$cookie.get("ltrTheme")?"Admin":"ادمین" }}
        </h4>
      </div>
    </div>
    <h1 class="blackColor06 width90 margin-auto">{{ data.title }}</h1>
    <double-line class="width50" />
    <div class="detail">
      <span> {{ `${data.commentCount} ${this.$cookie.get("ltrTheme")?'Comment':'نظر'}` }} </span>
    <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8,11a1,1,0,1,0,1,1A1,1,0,0,0,8,11Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,12,11Zm4,0a1,1,0,1,0,1,1A1,1,0,0,0,16,11ZM12,2A10,10,0,0,0,2,12a9.89,9.89,0,0,0,2.26,6.33l-2,2a1,1,0,0,0-.21,1.09A1,1,0,0,0,3,22h9A10,10,0,0,0,12,2Zm0,18H5.41l.93-.93a1,1,0,0,0,.3-.71,1,1,0,0,0-.3-.7A8,8,0,1,1,12,20Z"/></svg>
      <span> {{ `${data.like} ${this.$cookie.get("ltrTheme")?"Like":"لایک"}` }} </span>
    
<svg  @click="addLike(data.id)" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25" height="25"
	 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;cursor: pointer;" xml:space="preserve">
<g>
	<g id="heart_x5F_stroke">
		<g>
			<path :id="'heartSVG'+data.id" style="fill:#030104;" d="M23.113,6c2.457,0,4.492,1.82,4.836,4.188L16.004,23.906L4.051,10.188C4.395,7.82,6.43,6,8.887,6
				c2.016,0,3.855,2.164,3.855,2.164L16,11.625l3.258-3.461C19.258,8.164,21.098,6,23.113,6 M23.113,2
				c-2.984,0-5.5,1.578-7.113,3.844C14.387,3.578,11.871,2,8.887,2C3.984,2,0,5.992,0,10.891v0.734L16.008,30L32,11.625v-0.734
				C32,5.992,28.016,2,23.113,2L23.113,2z"/>
		</g>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>

      <span>
        {{`${this.$cookie.get("ltrTheme")?data.timeToRead+'Minutes'+' Time training'  :data.timeToRead+'دقیقه'+' زمان آموزش'}`}}
        
        
        
      </span>
     <svg class="cookingTimerSvg" width="25" height="25" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 0v1h1v.03c-1.7.24-3 1.71-3 3.47 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.45-.1-.87-.25-1.25l-.91.38c.11.29.16.57.16.88 0 1.39-1.11 2.5-2.5 2.5s-2.5-1.11-2.5-2.5 1.11-2.5 2.5-2.5c.3 0 .59.05.88.16l.34-.94c-.23-.08-.47-.12-.72-.16v-.06h1v-1h-3zm5 1.16s-3.65 2.81-3.84 3c-.19.2-.19.49 0 .69.19.2.49.2.69 0 .2-.2 3.16-3.69 3.16-3.69z"
  />
</svg>
    </div>
    <div class="cookingRoute width90  d-flex justify-content-end">
        <router-link class="d-flex justify-content-around" :to="`cooking-detail/${data.id}/${$root.slugGenerator(data.title)}`">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <image
          id="Layer_2716"
          data-name="Layer 2716"
          width="24"
          height="24"
          xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAatJREFUSEu9lksrRVEUx91b3nkNMECSCRlIoShFBsrAQAkxMPcxfAcjAwbyKnXv4JaRAVEoGYiJ5DWQCXlcj8LvX3vfTqd7ziFtu37tffZaZ/3X3medfU4sUVGVE9KKsdVBDZRBofFN0z/ADVzCS1CMWICAArVBswn8Qf8MCqwmu8RzjdAJ/aHHntHLJqCM+6AS7uAULkwgCakpsFZUD00e303GV5noDPwCjcwNaB4O4AhevTdkGRcw1wrt8AUbcGb9vAK1TA7Bp3E6jwjsNzeY5OL0SbiWgxXQno5ACaTgt8GtmEQG4RHWIG0Furnogi3Y+0Hmpfg8mdX63TuZ6IFd2JFAEYNx0ANchvcIARXAPMzBTBbfPObGQIWwJAFVgZal7Pcjgvdi1/5qK6dgIcC/w6wiJYF+LlpgBW5DBJR5wgSfpp8N8a3GNgrHEhhmUA6L8BZwk5JYB+19VHCFyIcJuJeABipNrUC9v6m+t0HlNwmrIZlbk3y1gvi/CDjfIucP2XmZOn/R9OSdHhUScH7YScTpcW1fEKcfHCvi9JNpRZx+9L1HzZ9/W74BqCOenYm/r8wAAAAASUVORK5CYII="
        />
      </svg>
      <span>{{$cookie.get('ltrTheme')?'See More':'مشاهده جزئیات'}}</span>
    </router-link>
    </div>
  </div>
</template>
<script>
import doubleLine from "@/components/front/shared/doubleLine.vue";
export default {
  components: { doubleLine },
  props: {
    data: Object
  },
  methods:{
	  addLike(id){
		  this.$axios.post(`Recipe/AddLike?id=${id}`).then(res=>{
              this.$toast.success(res.data.message);
			  document.getElementById("heartSVG"+id).classList.add("redSvg");
		  })
	  },
    goToRoute(path){
      if(window.innerWidth<1000)
      this.$router.push(path)
    }
  }
};
</script>
<style>
.cookingCart .detail svg path.redSvg{
	fill: red !important;
}
</style>
